import {
    // FILE_UPLOAD,
    CREATE_SJFSUPPORTTICKETS,
    RETRIEVE_SJFSUPPORTTICKETS,
    UPDATE_SJFSUPPORTTICKETS,
    DELETE_SJFSUPPORTTICKETS,
} from "./type";
import SJFSupportTickets from "../service/sjfSupportTickets";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFSupportTickets.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFSupportTickets.create(data);
        dispatch({
            type: CREATE_SJFSUPPORTTICKETS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFSupportTickets.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFSUPPORTTICKETS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFSupportTickets.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFSUPPORTTICKETS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFSupportTickets.update(data);
        dispatch({
            type: UPDATE_SJFSUPPORTTICKETS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await SJFSupportTickets.changeStatus(data);
//         dispatch({
//             type: UPDATE_SJFSUPPORTTICKETS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFSupportTickets.trash(data);
        dispatch({
            type: DELETE_SJFSUPPORTTICKETS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};